var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rmr-soft-badge',{attrs:{"label":_vm.presentation.label,"color":_vm.presentation.color,"background":_vm.presentation.background,"icon-src":_vm.presentation.icon,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }